import { render, staticRenderFns } from "./TournamentRegister.vue?vue&type=template&id=369ea6e8&scoped=true"
import script from "./TournamentRegister.vue?vue&type=script&lang=js"
export * from "./TournamentRegister.vue?vue&type=script&lang=js"
import style0 from "./TournamentRegister.vue?vue&type=style&index=0&id=369ea6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369ea6e8",
  null
  
)

export default component.exports